module.exports = __webpack_public_path__ + "img/item_Story_21.891f16db.jpeg";